import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Globe } from 'lucide-react';
import { t } from '../../lib/i18n';

const activeClass = 'bg-[var(--lux-gold)] text-[var(--lux-ink)] hover:bg-[var(--lux-gold-2)]';
const inactiveClass = 'bg-[var(--lux-panel)] border-white/10 text-white hover:bg-[var(--lux-panel-2)]';

export const LanguageCard = ({ language, onChange }) => (
  <Card className="bg-lux-panel/90 border-white/[0.08]" data-testid="settings-language-card">
    <CardHeader>
      <CardTitle className="flex items-center gap-2 text-white">
        <Globe className="w-5 h-5 text-[var(--lux-gold)]" />
        {t('language', language)}
      </CardTitle>
    </CardHeader>
    <CardContent>
      <div className="flex gap-3">
        <Button
          data-testid="language-fr-button"
          onClick={() => onChange('fr')}
          variant={language === 'fr' ? 'default' : 'outline'}
          className={language === 'fr' ? activeClass : inactiveClass}
        >
          {t('french', language)}
        </Button>
        <Button
          data-testid="language-en-button"
          onClick={() => onChange('en')}
          variant={language === 'en' ? 'default' : 'outline'}
          className={language === 'en' ? activeClass : inactiveClass}
        >
          {t('english', language)}
        </Button>
      </div>
    </CardContent>
  </Card>
);
